import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { SearchIcon } from "../../assets/SideBar/svgs";
import { getAllGalleries } from "../../utils/api-calls";
import Loading from "../Loading/Loading";
import {
  AddNewBtn,
  MembersSearch,
  MembersSearchBtn,
  MembersSearchCompCon,
  MembersSearchInput,
} from "../Members/Members.styles";
import AddGallery from "../Modals/AddGallery";
import {
  GalleryContainer,
  GalleryHeader,
  GalleryImageCard,
  GalleryImageCardTextLine,
  GalleryImagesHolder,
  PaginationContainer,
  PaginationLink,
} from "./Gallery.styles";
import SingleGallery from "./SingleGallery";

const Gallery = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [searchValue, setSearchValue] = useState("");
  const [addGallery, setAddGallery] = useState(false);
  const [showSingle, setShowSingle] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const displayAddGallery = () => {
    setAddGallery(!addGallery);
  };
  const displaySingleModal = () => {
    setShowSingle(!showSingle);
  };

  const { isLoading, isFetching, isError, data } = useQuery(
    ["all-galleries", currentPage],
    () => getAllGalleries(currentPage),
    {
      refetchOnWindowFocus: false,
      select: (data) => data.data,
    }
  );

  const searchHandler = () => {
    const searchPattern = new RegExp(searchValue, "i");
    return data?.data?.filter((item) => item.name.search(searchPattern) >= 0) || [];
  };

  const searchResult = searchHandler();

  const handlePageChange = (url) => {
    const page = new URL(url).searchParams.get("page");
    setCurrentPage(Number(page));
  };

  return (
    <>
      {addGallery && <AddGallery close={displayAddGallery} />}
      {showSingle && <SingleGallery close={displaySingleModal} id={itemId} />}
      <GalleryContainer>
        <GalleryHeader>Gallery</GalleryHeader>

        <MembersSearch>
          <MembersSearchCompCon>
            <MembersSearchInput
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search by name"
            />
            <MembersSearchBtn onClick={searchHandler}>
              <SearchIcon style={{ width: "15px", height: "15px" }} />
            </MembersSearchBtn>
          </MembersSearchCompCon>

          <AddNewBtn onClick={displayAddGallery}>Add New</AddNewBtn>
        </MembersSearch>

        {isLoading || isFetching ? (
          <Loading loading={isLoading || isFetching} />
        ) : isError ? (
          <small>Can't load galleries.</small>
        ) : (
          <>
            <GalleryImagesHolder>
              {searchResult.length > 0
                ? searchResult.map((item) => (
                    <GalleryImageCard
                      key={item.id}
                      onClick={() => {
                        setItemId(item.id);
                        displaySingleModal();
                      }}
                    >
                      <GalleryImageCardTextLine size="bigger">
                        {item.name}
                      </GalleryImageCardTextLine>
                      <GalleryImageCardTextLine>
                        {item.date_taken}
                      </GalleryImageCardTextLine>
                    </GalleryImageCard>
                  ))
                : data.data.map((item) => (
                    <GalleryImageCard
                      key={item.id}
                      onClick={() => {
                        setItemId(item.id);
                        displaySingleModal();
                      }}
                    >
                      <GalleryImageCardTextLine size="bigger">
                        {item.name}
                      </GalleryImageCardTextLine>
                      <GalleryImageCardTextLine>
                        {item.date_taken}
                      </GalleryImageCardTextLine>
                    </GalleryImageCard>
                  ))}
            </GalleryImagesHolder>
            <PaginationContainer>
              {data.links.map((link) => (
                <PaginationLink
                  key={link.label}
                  active={link.active}
                  onClick={() => handlePageChange(link.url)}
                >
                  {link.label}
                </PaginationLink>
              ))}
            </PaginationContainer>
          </>
        )}
      </GalleryContainer>
    </>
  );
};

export default Gallery;
